import { StatusBadge, useLocalization } from '@magicdoor/ui';
import type { StatusConfig } from '@magicdoor/ui';
import type { Component } from 'solid-js';

export const MaintenanceRequestUrgency: Component<{ class?: string; urgency?: `${MagicDoor.Api.Urgency}` }> = (props) => {
  const { t } = useLocalization();
  const urgencyStatusMap: Record<MagicDoor.Api.Urgency, StatusConfig> = {
    urgent: { label: t('Urgent'), color: 'text-light-danger' },
    high: { label: t('High'), color: 'text-light-purple' },
    medium: { label: t('Medium'), color: 'text-light-green' },
    low: { label: t('Low'), color: 'text-light-warning' },
    none: { label: t('None'), color: 'text-light-gray-level01' },
  };

  return <StatusBadge class={props.class} status={props.urgency} statusMap={urgencyStatusMap} />;
};
